export function snakeToCamel(str) {
  return str.replace(/_([a-z])/g, (_, char) => char.toUpperCase())
}

export function toCamelCase(value) {
  if (!value) {
    return value
  }

  if (Array.isArray(value)) {
    return value.map(toCamelCase)
  }

  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [snakeToCamel(key), toCamelCase(val)])
    )
  }

  return value
}
